var _path, _path2, _path3, _path4, _path5, _path6, _path7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgYellowCrown(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 18C0 8.05888 8.05888 0 18 0C27.9411 0 36 8.05888 36 18C36 27.9411 27.9411 36 18 36C8.05888 36 0 27.9411 0 18Z",
    fill: "#F0D22F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18 13.625C18.8629 13.625 19.5625 12.9254 19.5625 12.0625C19.5625 11.1996 18.8629 10.5 18 10.5C17.1371 10.5 16.4375 11.1996 16.4375 12.0625C16.4375 12.9254 17.1371 13.625 18 13.625Z",
    stroke: "#ECEFF3",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.1875 15.8125C26.0504 15.8125 26.75 15.1129 26.75 14.25C26.75 13.3871 26.0504 12.6875 25.1875 12.6875C24.3246 12.6875 23.625 13.3871 23.625 14.25C23.625 15.1129 24.3246 15.8125 25.1875 15.8125Z",
    stroke: "#ECEFF3",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8125 15.8125C11.6754 15.8125 12.375 15.1129 12.375 14.25C12.375 13.3871 11.6754 12.6875 10.8125 12.6875C9.94956 12.6875 9.25 13.3871 9.25 14.25C9.25 15.1129 9.94956 15.8125 10.8125 15.8125Z",
    stroke: "#ECEFF3",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3758 13.4961L14.8742 19.25L11.7969 15.4625",
    stroke: "#ECEFF3",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M24.2039 15.4625L21.1266 19.25L18.625 13.4961",
    stroke: "#ECEFF3",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0703 15.791L12.2891 23.1027C12.3135 23.2486 12.3888 23.3811 12.5016 23.4766C12.6145 23.5722 12.7576 23.6246 12.9055 23.6246H23.0961C23.244 23.6246 23.3871 23.5722 23.4999 23.4766C23.6128 23.3811 23.6881 23.2486 23.7125 23.1027L24.9313 15.791",
    stroke: "#ECEFF3",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYellowCrown);
export default __webpack_public_path__ + "static/media/yellowCrown.bb606d8ac32bfb693c1ccf49e58d1cad.svg";
export { ForwardRef as ReactComponent };